// DF-0573 — the e-mail rule sale_api applies to an order (DRF `EmailField` =
// Django 5.2 `EmailValidator`), ported so the checkout refuses exactly what the
// server would refuse, under the field, before anything is sent. The site used
// to check « contains @ and . » only: `prenom.nom@gmail`, `jean..dupont@…`,
// `hélène@orange.fr` passed the page, took a 400 from sale_api, and the customer
// read « Échec de la commande » eight times in a row (SUSHI Auxerre, 2026-10-20).
//
// Same regexes as django/core/validators.py, written without lookbehind: an old
// Safari fails to PARSE `(?<!…)`, which would take the whole checkout down.

// dot-atom | quoted-string — ASCII only, no leading/trailing/double dot.
const USER_RE =
  // eslint-disable-next-line no-control-regex
  /^(?:[-!#$%&'*+/=?^_`{}|~0-9a-z]+(?:\.[-!#$%&'*+/=?^_`{}|~0-9a-z]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f!#-[\]-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")$/i;

// DomainNameValidator: labels of 1–63 chars, never starting or ending with
// « - », then a TLD of 2–63 letters (no digit) or an `xn--` punycode one.
const LABEL = '[a-z\\u00a1-\\uffff0-9](?:[a-z\\u00a1-\\uffff0-9-]{0,61}[a-z\\u00a1-\\uffff0-9])?';
const TLD = '(?:[a-z\\u00a1-\\uffff][a-z\\u00a1-\\uffff-]{0,61}[a-z\\u00a1-\\uffff]|xn--[a-z0-9]{1,59})';
const DOMAIN_RE = new RegExp(`^(?:${LABEL}\\.)+${TLD}$`, 'i');
const LITERAL_RE = /^\[[a-f0-9:.]+\]$/i;

/** True when sale_api's `EmailField` accepts `value` (trimmed, as DRF does). */
export function isValidEmail(value: string): boolean {
  const email = value.trim();
  if (!email || !email.includes('@') || email.length > 320) return false;
  const at = email.lastIndexOf('@');
  const user = email.slice(0, at);
  const domain = email.slice(at + 1);
  if (!USER_RE.test(user)) return false;
  return domain === 'localhost' || DOMAIN_RE.test(domain) || LITERAL_RE.test(domain);
}

// sale_api `OnlineCustomerSerializer` max lengths: past them the whole order is
// a field 400, so the inputs simply stop there.
export const CUSTOMER_NAME_MAX = 128;
export const CUSTOMER_PHONE_MAX = 32;
